import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { openModal } from '../../../redux/reducers/modal';
// components
import Icon from '../../../components/Icon/Icon';
import Button from '../../../components/Button/Button';
// styles
import classnames from 'classnames/bind';
import styles from './SkillBlock.mod.css';

let cx = classnames.bind(styles);

const SkillBlock = ({
  skill,
  defaultSkills,
  isEditMode,
  openModal,
  user,
  ...otherProps
}) => {
  const color = user.profile_color || '#33C370';
  return (
    <div className={cx('wrapper')}>
      <div
        className={cx('container', { edit: isEditMode })}
        style={{ borderColor: color }}
        {...otherProps}
      >
        <p className={cx('text')}>{skill.title}</p>
        {isEditMode && (
          <div className={cx('buttons-section', 'fadeIn')}>
            <Button
              onClick={() => openModal('UPDATE_SKILL', { skill, color })}
              className={cx('button', 'edit-button')}
              plain
            >
              <Icon type="pen" color="black" className={cx('button-icon')} />
              <span className={cx('button-text')}>Edit</span>
            </Button>

            <Button
              onClick={() => openModal('DELETE_SKILL', { skill, color })}
              className={cx('button', 'delete-button')}
              plain
            >
              <Icon type="delete" color="red" className={cx('button-icon')} />
              <span className={cx('button-text')}>Delete</span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

SkillBlock.propTypes = {
  skills: T.arrayOf(
    T.shape({
      value: T.oneOfType([T.string, T.number]),
      label: T.string.isRequired
    })
  )
};

export default connect(
  state => ({
    user: state.auth.user,
    defaultSkills: state.skills.defaultSkills
  }),
  { openModal }
)(SkillBlock);



// WEBPACK FOOTER //
// ./src/containers/Skills/components/SkillBlock.jsx